import { render, staticRenderFns } from "./LoadApprovalLogs.vue?vue&type=template&id=0e9f3e6f&scoped=true"
import script from "./LoadApprovalLogs.vue?vue&type=script&lang=js"
export * from "./LoadApprovalLogs.vue?vue&type=script&lang=js"
import style0 from "./LoadApprovalLogs.vue?vue&type=style&index=0&id=0e9f3e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9f3e6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
